import { ReadonlyRepositoryObjectService, Result } from '@softline/core';
import { computed, inject, Injectable } from '@angular/core';
import { LieferantenQuery } from '../types/lieferanten-query';
import { LieferantenWwsRepository } from '../repositories/lieferanten-wws.repository';
import { SupplierWws } from '../types/supplier-wws';
import { SupplierIdService } from './supplier-id.service';

@Injectable()
export class LieferantenWwsService extends ReadonlyRepositoryObjectService<
  SupplierWws,
  Result<SupplierWws>,
  LieferantenQuery
> {
  readonly #supplierIdService = inject(SupplierIdService);

  supplierId = computed(() => this.#supplierIdService.supplierId()());
  override params = computed(() => {
    return { id: this.supplierId() };
  });

  constructor() {
    super(inject(LieferantenWwsRepository));
  }

  protected override getValue(
    result: Result<SupplierWws> | null | undefined
  ): SupplierWws {
    return result as any;
  }
}
